import { api } from "./api";
import {
  CurrentUserResponse,
  HubspotOwnerLink,
  UpdateProfileRequest,
  UpdateProfileResponse,
  ChangePasswordRequest,
  ChangePasswordResponse,
} from "Models/auth";

export const userApi = api.injectEndpoints({
  endpoints: (build) => ({
    getMe: build.query<CurrentUserResponse, void>({
      query: () => ({
        url: "auth/me",
        method: "GET",
      }),
    }),
    getHubspotOwnerLink: build.query<HubspotOwnerLink, void>({
      query: () => ({
        url: "auth/me/hubspot-owner",
        method: "GET",
      }),
      providesTags: ["HubspotOwnerLink"],
    }),
    updateProfile: build.mutation<UpdateProfileResponse, UpdateProfileRequest>({
      query: (params) => ({
        url: "auth/me",
        method: "PATCH",
        body: params,
      }),
      // Confirming or clearing a link changes the link state, so the cached
      // `suggested` must not survive the write — otherwise the confirm prompt
      // stays on screen until a reload.
      invalidatesTags: ["HubspotOwnerLink"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(userApi.util.updateQueryData("getMe", undefined, () => data.user));
        } catch {}
      },
    }),
    changePassword: build.mutation<ChangePasswordResponse, ChangePasswordRequest>({
      query: (params) => ({
        url: "auth/change-password",
        method: "POST",
        body: params,
      }),
    }),
  }),
});

export const {
  useGetMeQuery,
  useLazyGetMeQuery,
  useGetHubspotOwnerLinkQuery,
  useUpdateProfileMutation,
  useChangePasswordMutation,
} = userApi;
